import React from 'react';
import Highlights from '../Services/Highlights'
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSectionServices'
import Hero from '../HeroNoticiasFr'
import NoticiasN from '../Noticias/NoticiasFr'
import HeroCorp from '../HeroCorp'
import Footer from '../../Footer/FooterFr';

function Noticias(){
    return (
        <div>
            <Hero/>
            <NoticiasN/>
            <Footer/>
{/*            
            <HeroCorp/> */}
            
        </div>
    );
}

export default Noticias;
